import { Table } from '@tanstack/react-table';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LedgerAccountKindPicker } from '@work4all/components/lib/components/entity-picker/ledger-account-kind-picker/LedgerAccountKindPicker';
import { useSalesOpportunityGroups } from '@work4all/components/lib/components/entity-picker/sales-opportunities-group-picker/useSalesOpportunityGroups';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { LedgerAccount } from '@work4all/models/lib/Classes/LedgerAccount.entity';

interface IProps {
  table: Table<LedgerAccount>;
}

export function LedgerAccountTableQuickFilters(props: IProps) {
  const { table } = props;

  const { data } = useSalesOpportunityGroups();

  const { t } = useTranslation();

  const kindColummn = table.getColumn('kind');

  const handleKindChange = useCallback(
    (value: { id: string; name: string }) => {
      if (!value) {
        kindColummn?.setFilterValue(null);
      } else {
        kindColummn?.setFilterValue({
          value: [value],
          filterType: kindColummn.columnDef.filterType,
        });
      }
    },
    [kindColummn]
  );

  if (!data) return null;

  return (
    <>
      <Divider
        title={t('COMMON.GENERAL_LEDGER_ACCOUNT_TYPE')}
        style={{ padding: '0.75rem 1rem' }}
      />
      <LedgerAccountKindPicker
        multiple={false}
        onChange={handleKindChange}
        value={(kindColummn.getFilterValue() as any)?.value?.[0]}
      />
    </>
  );
}
